import React from "react";
import LoginContainer from "modules/Authentication/containers/LoginContainer/LoginContainer";

type Props = {};

const Login = (props: Props) => {
  return <LoginContainer />;
};

export default Login;
